import { render } from "./EditBlog.vue?vue&type=template&id=2ce58c98&scoped=true"
import script from "./EditBlog.vue?vue&type=script&lang=js"
export * from "./EditBlog.vue?vue&type=script&lang=js"

import "./EditBlog.vue?vue&type=style&index=0&id=2ce58c98&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce58c98"]])

export default __exports__